<div class="agenx-checkbox__container">
  <label [ngClass]="labelClasses">
    <input [id]="idInput" class="agenx-checkbox__checkbox" [value]="value" [checked]="checked" [formControl]="control"
      type="checkbox" [name]="nameInput" (click)="sendValue()">
    {{ label }}
  </label>
</div>
